






import { defineComponent, onMounted } from "@nuxtjs/composition-api";
import { Loader } from "@googlemaps/js-api-loader";

export default defineComponent({
  name: "MediaMap",
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const loader = new Loader({
      apiKey: process.env.GOOGLE_MAP_API_KEY,
      version: "weekly",
      libraries: ["places"],
    });

    const mapOptions = {
      center: {
        lat: 80,
        lng: 100,
      },
      zoom: 4,
    };

    onMounted(async () => {
      // Promise
      loader
        .load()
        .then((google) => {
          new google.maps.Map(document.getElementById("map"), mapOptions);
        })
        .catch(() => {
          // do something
        });
    });

    return {};
  },
});
